import React from 'react';
import { XIcon } from 'lucide-react';
type PolicyModalProps = {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
};
export const PolicyModal = ({
  title,
  onClose,
  children
}: PolicyModalProps) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" data-id="element-657">
      <div className="bg-white rounded-2xl w-full max-w-3xl p-6 max-h-[90vh] flex flex-col" data-id="element-658">
        <div className="flex items-center justify-between mb-6" data-id="element-659">
          <h2 className="text-xl font-bold text-[#6B4B3E]" data-id="element-660">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-[#FFF0E6] rounded-full transition-colors" data-id="element-661">
            <XIcon size={20} className="text-[#6B4B3E]" data-id="element-662" />
          </button>
        </div>
        <div className="overflow-y-auto flex-grow pr-4" data-id="element-663">
          <div className="prose prose-brown max-w-none" data-id="element-664">{children}</div>
        </div>
      </div>
    </div>;
};